const timeBack = {
  path: "/timeBank", //主体
  name: "timeBank",
  redirect: '/teamRecruit',
  component: () => import ("../views/timeBank/main"),
  children: [
    {
      path: '/teamRecruit',
      name: 'teamRecruit',
      mate: {
        title: '团队招募'
      },
      component: () => import ("../views/timeBank/teamRecruit/index")
    },
    {
      path: '/recruitRecruit',
      name: 'recruitRecruit',
      mate: {
        title: '活动招募'
      },
      component: () => import ("../views/timeBank/recruitRecruit/recruitRecruit")
    },
    {
      path: '/volunteer',
      name: 'volunteer',
      mate: {
        title: '志愿者管理'
      },
      component: () => import ("../views/timeBank/volunteer/index")
    },
    {
      path: '/activityManage',
      name: 'activityManage',
      mate: {
        title: '用户活动需求管理'
      },
      component: () => import ("../views/timeBank/activityManage/index")
    },
    {
      path: '/loveBusiness',
      name: 'loveBusiness',
      mate: {
        title: '爱心商家'
      },
      component: () => import ("../views/timeBank/business/index"),
      redirect: '/administrators',
      children: [
        {
          path: '/administrators',
          name: 'administrators',
          mate: {
            title: "商家库"
          },
          component: () => import('../views/timeBank/business/administrators')
        },
        {
          path: '/business',
          name: 'business',
          mate: {
            title: "商家"
          },
          component: () => import('../views/timeBank/business/business')
        }
      ]
    },
    {
      path: '/recommend',
      name: 'recommend',
      mate: {
        title: '好人推荐'
      },
      component: () => import ("../views/timeBank/recommend/index")
    },
    {
      path: '/giftRecord',
      name: 'giftRecord',
      mate: {
        title: '礼品兑换记录'
      },
      component: () => import ("../views/timeBank/giftRecord/index")
    },
    {
      path: '/volunteerService',
      name: 'volunteerService',
      mate: {
        title: '志愿者服务时长'
      },
      component: () => import ("../views/timeBank/volunteerService")
    },
  ]
}

export default timeBack
